import { useEffect } from 'react';

const useMessageReceivedFromOrigin = <T>(target: string, origin: string, callback: (data: T) => void) => {  
  useEffect(() => {
    const handleMessageReceived = (message: MessageEvent) => {
      const element: any = document.getElementById(target);
      if (message.source !== element?.contentWindow) return;
      if (message.origin === origin) {
        callback(message.data);
      }
    };

    window.addEventListener('message', handleMessageReceived);
    return () => window.removeEventListener('message', handleMessageReceived);
  }, [callback, origin, target]);
}

const useTrustedMessageListener = <T>(callback: (data: T) => void) => {
  useEffect(() => {
    const handleMessageReceived = (message: MessageEvent) => {      
      // Only accept messages from trusted backend
      if (process.env.REACT_APP_API_ROOT_V2!!.indexOf(message.origin) < 0) return;
      callback(message.data);
    };

    window.addEventListener('message', handleMessageReceived);
    return () => window.removeEventListener('message', handleMessageReceived);
  }, [callback]);
};

export {
  useMessageReceivedFromOrigin,
  useTrustedMessageListener
};
